module.exports = __webpack_public_path__ + "static/media/festival_03.63972cdb.jpg";